export const RateAiResponseType = {
  LIKE: 'like',
  DISLIKE: 'dislike',
} as const;

export type RateAiResponseKind = typeof RateAiResponseType[keyof typeof RateAiResponseType];
